import { render, staticRenderFns } from "./addQSForm.vue?vue&type=template&id=4705dca8&scoped=true&"
import script from "./addQSForm.vue?vue&type=script&lang=js&"
export * from "./addQSForm.vue?vue&type=script&lang=js&"
import style0 from "./addQSForm.vue?vue&type=style&index=0&id=4705dca8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4705dca8",
  null
  
)

export default component.exports